import { EmiPlanCardComponent } from "./emi-plan-card/emi-plan-card.component";
import { ConfettiComponent } from "./confetti/confetti.component";
import { PlanCalculatorComponent } from "./plan-calculator/plan-calculator.component";

export {
    EmiPlanCardComponent,
    ConfettiComponent,
    PlanCalculatorComponent
}